/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner
 */
export interface GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner
     */
    title?: string | null;
}

/**
 * Check if a given object implements the GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner interface.
 */
export function instanceOfGetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON(value?: GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'phone': value.phone,
        'email': value.email,
        'title': value.title,
    };
}

